module.exports = __webpack_public_path__ + "static/media/marker.b10c1c23.svg";